var alignmentStyle = {"alignLeft":"_7udjA","textWrapNowrap":"J2ENn","alignRight":"fvXHM","alignCenter":"RMv7A","sizeFullWidth":"FMrjL","renderedInTable":"g74d8","sizeOriginal":"sejKe","sizeContent":"y2xDU","sizeSmall":"D9pF8","sizeSmallCenter":"LsxLX","flex":"w3uEh","LEFT":"DSHS4","CENTER":"BZ6KH","RIGHT":"_-4TVI","AUTO":"ujaSx","JUSTIFY":"v900F"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-6413c0c1.js.map
